angular.module('mtic.components.modules.learningMap', []);

angular.module('mtic.components.modules.learningMap')
.service('learningMapUtil', function(C3_ASSET_URL, $log, $http, mapItemFactory, PIXI) {

  /**
   * Private vars
   */

   // none


  /**
   * Public Methods
   * @type {Object}
   */
  var learningMapUtil = {

    /**
     * Handles the intro animation/fade in
     * @return {DragInfoSettings}
     */
    createCloudManager: function(){
      var progress = 0;
      var randomMod = Math.random();
      var clouds = [];

      var cloud_graphic = new PIXI.Graphics();

      cloud_graphic.beginFill(0xeef0f1);
      cloud_graphic.drawCircle(100, 100, 100);
      cloud_graphic.endFill();

      var cloud_tex = cloud_graphic.generateCanvasTexture(PIXI.SCALE_MODES.NEAREST);

      var overlay = new PIXI.Graphics();

      overlay.beginFill(0xeef0f1);
      overlay.drawRect(0, 0, 100, 100);
      overlay.endFill();

      var overlay_sprite = new PIXI.Sprite(overlay.generateCanvasTexture(PIXI.SCALE_MODES.NEAREST));

      return {
        overlay_sprite: overlay_sprite,
        update: function () {
          progress = Math.min(progress + 1, 100);
          overlay_sprite.alpha = (100 - progress) / 100.0;
        },
        onResize: function (width, height) {
          overlay_sprite.width = width;
          overlay_sprite.height = height;
        }
      }
    },

    /**
     * Create Object that tracks intertial click and drag panning around the screen
     * @return {DragInfoSettings}
     */
    getDragInfoSettings: function () {
      return {
        dragging: false,
        velocity: {
          x: 0,
          y: 0
        },
        last_mouse_pos: {
          x: 0,
          y: 0,
        },
        start_drag_mouse_pos: {
          x: 0,
          y: 0
        },
        start_drag_pos: {
          x: 0,
          y: 0
        }
      }
    }

  };

  return learningMapUtil;

});
